import { Card, CardContent } from "@/components/ui/card";
import { Shield, CheckCircle2, Award, Clock, FileCheck, Users, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

const TrustSignals = () => {
  const signals = [
    {
      icon: <Award className="w-10 h-10" />,
      title: "5+ Years in Business",
      description: "Established in 2020, serving San Antonio with excellence since day one"
    },
    {
      icon: <Users className="w-10 h-10" />,
      title: "Exceptional 5 Star Google Reviews",
      description: "Verified Google reviews from satisfied clients across San Antonio"
    },
    {
      icon: <ShieldCheck className="w-10 h-10" />,
      title: "Official JBSA Base Access",
      description: "Verified access to Lackland AFB, Fort Sam Houston & Randolph AFB",
      link: "/jbsa-military-transportation"
    }
  ];

  return (
    <section className="py-20 luxury-gradient">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-primary text-sm font-semibold tracking-wider uppercase">
            Your Peace of Mind
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 text-foreground">
            Licensed, Insured & Trusted
          </h2>
          <p className="text-muted-foreground text-lg mt-4 max-w-2xl mx-auto">
            Rick's Black Car Service operates with full regulatory compliance, comprehensive insurance coverage, and a proven track record of excellence in San Antonio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {signals.map((signal, index) => {
            const cardContent = (
              <CardContent className="p-8 space-y-4">
                <div className="flex justify-center text-primary">{signal.icon}</div>
                <h3 className="text-xl font-semibold text-foreground">{signal.title}</h3>
                <p className="text-muted-foreground">{signal.description}</p>
              </CardContent>
            );
            
            return signal.link ? (
              <Link key={index} to={signal.link}>
                <Card className="card-luxury text-center hover:scale-105 transition-transform duration-300 h-full">
                  {cardContent}
                </Card>
              </Link>
            ) : (
              <Card key={index} className="card-luxury text-center hover:scale-105 transition-transform duration-300">
                {cardContent}
              </Card>
            );
          })}
        </div>

        <div className="mt-16 max-w-4xl mx-auto">
          <Card className="card-luxury">
            <CardContent className="p-8">
              <h3 className="text-2xl font-serif font-bold text-foreground mb-6 text-center">
                Professional Driver Vetting Process
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold text-foreground">Background Checks</p>
                      <p className="text-muted-foreground text-sm">Comprehensive criminal and driving record verification</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold text-foreground">Drug Screening</p>
                      <p className="text-muted-foreground text-sm">Pre-employment and random testing program</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold text-foreground">Professional Training</p>
                      <p className="text-muted-foreground text-sm">Defensive driving and customer service certification</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <ShieldCheck className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold text-foreground">DBIDS Credentialed</p>
                      <p className="text-muted-foreground text-sm">Defense Biometric ID System clearance for JBSA base entry</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold text-foreground">Clean Driving Records</p>
                      <p className="text-muted-foreground text-sm">Minimum 5 years accident-free driving required</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold text-foreground">Professional Appearance</p>
                      <p className="text-muted-foreground text-sm">Business attire and grooming standards maintained</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold text-foreground">Confidentiality Training</p>
                      <p className="text-muted-foreground text-sm">Discretion and privacy protocols for all clients</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <ShieldCheck className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" />
                    <div>
                      <p className="font-semibold text-foreground">JBSA Vehicle Inspection</p>
                      <p className="text-muted-foreground text-sm">All vehicles meet military base security requirements</p>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
